import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { LocationService } from '../../../services/location.service';
import { CategoryService } from '../../../services/category.service';


@Component({
  selector: 'app-category-picker',
  templateUrl: './category-picker.component.html',
  styleUrls: ['./category-picker.component.scss']
})
export class CategoryPickerComponent implements OnInit, OnChanges {
  @Input() categoryId: number;
  @Input() _placeholder: string = 'Please Select';
  @Output() onCategoryIdSet = new EventEmitter<number>();
  @Output() onCategorySet = new EventEmitter<any>();

  categories = [];


  constructor(public categoryService: CategoryService) {
  }

  ngOnInit(): void {
    this.categoryService.getAll().then((categories) => {
      this.categories = categories;
    });

  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  onChanged() {
    this.onCategoryIdSet.emit(this.categoryId);
    var category = this.categories.find(a => a.id == this.categoryId);
    this.onCategorySet.emit(category);
  }

}
